import { Router } from '@remix-run/router';

import * as addressLookup from './addressLookup.service';
import * as authorization from './authorization.service';
import * as bankAccountLinking from './bank-account-linking.service';
import * as config from './config.service';
import * as datadog from './datadog/datadog.service';
import * as deviceData from './deviceData.service';
import * as fleetVerification from './fleet-verification.service';
import * as logrocket from './logrocket/logrocket.service';
import * as persona from './persona.service';
import * as qualification from './qualification.service';
import * as consent from './record-consent.service';
import * as refData from './reference-data.service';
import * as segment from './segment/segment-analytics.service';
import * as statsig from './statsig';

const createServices = ({ router }: { router: Router }) => ({
  router,
  api: {
    addressLookup,
    authorization,
    config,
    deviceData,
    fleetVerification,
    persona,
    qualification,
    refData,
    consent,
    bankAccountLinking,
    segment,
    statsig,
    datadog,
    logrocket,
  },
  window,
  env: import.meta.env.MODE,
  localStorage,
});

export type Services = ReturnType<typeof createServices>;
export { createServices };
